(ns kyber.subscriptions.i18n
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 :i18n/locale-key
 (fn [{k :i18n/locale-key} _] (or k :en)))
